// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapButton, BootstrapIcon } from '../../../../dsl/front';
import { PlayIcon } from '../../PlayIcon';
import VideoPlayer from '../../VideoPlayer/VideoPlayer';
let ArticleHeaderVideo = class ArticleHeaderVideo extends Vue {
    constructor() {
        // @Prop({ type: Object, required: true })
        // public readonly eventBus!: IEventbus
        super(...arguments);
        this.isPlayerFloating = false;
        this.isPlayerInitialised = false;
        this.videoAttrId = this.$id() + 'video';
        this.videoHeight = 300;
        this.scrollObserver = null;
    }
    get baseVideoMetadata() {
        var _a, _b;
        return {
            name: this.config.name,
            thumbnailUrl: (_b = (_a = this.config.thumbnail) === null || _a === void 0 ? void 0 : _a.src) !== null && _b !== void 0 ? _b : '',
            uploadDate: this.config.uploadDate
        };
    }
    /**
     * Handles the `@click` event on the "close" button.
     */
    onCloseBtnClick() {
        this.$emit('pause', {
            playerId: this.videoAttrId
        });
        // this.eventBus.emit('ui:video-player.pause', {
        //   playerId: this.videoAttrId
        // })
        this.unobservePlayerVisibility();
    }
    /**
     * Handles the `@click` event on the "play" button.
     */
    onPlayBtnClick() {
        this.$emit('play', {
            playerId: this.videoAttrId,
            autoplay: true
        });
        // this.eventBus.emit('ui:video-player.play', {
        //   playerId: this.videoAttrId,
        //   autoplay: true
        // })
    }
    onVideoInit() {
        this.observePlayerVisibility();
        this.isPlayerInitialised = true;
    }
    /**
     * Observes the player's visibility and react accordingly.
     */
    observePlayerVisibility() {
        if (!this.$refs.videoWrapper || !this.scrollObserver) {
            return;
        }
        this.videoHeight = this.$refs.videoWrapper.offsetTop * 0.50;
        this.scrollObserver.observe(this.$refs.videoWrapper);
    }
    /**
     * Stops the floating of the player and returns it to its original position.
     */
    unobservePlayerVisibility() {
        this.isPlayerFloating = false;
        // if (this.scrollObserver) {
        //   this.scrollObserver.disconnect()
        // }
    }
    toggleFloating(isFloating) {
        this.isPlayerFloating = isFloating;
    }
};
__decorate([
    Prop({ type: Object, required: true })
], ArticleHeaderVideo.prototype, "config", void 0);
ArticleHeaderVideo = __decorate([
    Component({
        name: 'ArticleHeaderVideo',
        components: {
            BootstrapButton,
            BootstrapIcon,
            PlayIcon,
            VideoPlayer
        },
        mounted() {
            // let topLimit = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--navbar-height'), 10)
            // if (!topLimit) {
            //   topLimit = 140
            // }
            // topLimit = 345
            const topLimit = 267;
            this.scrollObserver = new IntersectionObserver((entries) => {
                const outOfViewport = entries.find((entry) => !entry.isIntersecting);
                // float only if player is out of viewport and is above current scroll position (in case it doesn't fit in viewport because of an ad or banner)
                this.toggleFloating(!!outOfViewport && outOfViewport.target.getBoundingClientRect().top <= (topLimit));
                // if (outOfViewport) {
                // console.log('outOfViewport', outOfViewport.target.getBoundingClientRect().top, '<=', (topLimit))
                // }
                // this.toggleFloating(!this.isPlayerFloating)
            }, {
                rootMargin: `${-(topLimit)}px 0px 0px 0px`,
                threshold: [0, 1]
            });
            setTimeout(() => {
                this.$emit('play', {
                    playerId: this.videoAttrId,
                    autoplay: true,
                    muted: true
                });
                // this.eventBus.emit('ui:video-player.play', {
                //   playerId: this.videoAttrId,
                //   autoplay: true,
                //   muted: true
                // })
            }, 500);
        },
        beforeDestroy() {
            if (this.scrollObserver) {
                this.scrollObserver.disconnect();
            }
        },
        template: `
    <div class="article-header__image__yt-embed__wrapper" ref="videoWrapper">
    <!-- "Play" button -->
    <BootstrapButton @click="onPlayBtnClick"
                     class="article-header__image__play-btn p-0 shadow-none" aria-label="Odtwórz">
      <PlayIcon/>
    </BootstrapButton>

    <!-- YT embed -->
    <div class="article-header__image__yt-embed"
         :class="{ '--hidden': !isPlayerInitialised, '--floating': isPlayerFloating }">
      <!-- Player -->

      <VideoPlayer class="article-header__image__yt-embed__player"
                   :video="config.video"
                   :noThumbnail="!config.thumbnail"
                   :videoSettings="config.settings"
                   :baseVideoMetadata="baseVideoMetadata"
                   :videoAttrId="videoAttrId"
                   :videoAdsTag="config.videoAdsTag"
                   :origin="config.origin"
                   @init="onVideoInit"/>

      <!-- "Close" button -->
      <BootstrapButton class="article-header__image__yt-embed__close-btn btn-primary btn-square btn-sm"
                       @click="onCloseBtnClick" :class="{ 'd-none': !isPlayerFloating }">
        <BootstrapIcon name="close" size="small"/>
        <span class="visually-hidden">{{ $t('_.close') }}</span>
      </BootstrapButton>
    </div>
    <!-- END | YT embed -->
    </div>
  `
    })
], ArticleHeaderVideo);
export { ArticleHeaderVideo };
export default ArticleHeaderVideo;
